import { Injectable } from "@angular/core"

@Injectable()
export class TooltipService {
  components: any[] = []
  componentsV2: any[] = []
}
